module.exports = __webpack_public_path__ + "static/media/pricingWitnessLogo.385c7efb.webp";